// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"bb_bv","reviews__wrapper__list":"bb_fc","reviewSlider":"bb_fd"};